// External Dependencies:
import React from 'react'
import { v4 as uuidv4 } from 'uuid'

class Textarea extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			value: props.value
		}

		this.uid = uuidv4()
		this.refExpand = React.createRef()
		this.refTextarea = React.createRef()
	}

	componentDidUpdate( prevProps ) {
		const { value, expand } = this.props

		if ( expand && ! value && prevProps.value ) {
			this.updateHeight()
		}
	}

	handleChange = ( e ) => {
		this.setState( {
			value: e.target.value
		} )

		this.props.onChange( this.props.id, e.target.value )
	}

	handleKeyDown = ( e ) => {
		if ( this.props.onKeyDown ) {
			this.props.onKeyDown( e )
		}
	}

	handleInput = ( e ) => {
		const { expand } = this.props

		if ( expand ) {
			this.updateHeight()
		}
	}

	updateHeight = () => {
		let content = this.refTextarea.current.value
		content = content.replace( /\n/g, '<br>' )
		this.refExpand.current.innerHTML = content + '<br style="line-height: 3px;">';

		this.refExpand.current.style.visibility = 'hidden'
		this.refExpand.current.style.display = 'block'

		this.refTextarea.current.style.height = this.refExpand.current.offsetHeight + 'px'

		this.refExpand.current.style.visibility = 'visible'
		this.refExpand.current.style.display = 'none'
	}

	render() {
		const {
			id, label, value, required, uncontrolled,
			placeholder, rows = '10',
			expand
		} = this.props
		let theValue = value || ''
		let className = 'form-item form-textarea'

		if ( uncontrolled ) {
			theValue = undefined
		}

		if ( expand ) {
			className += ' is-expandable'
		}

		return (
			<div className={ className }>
				{ label &&
					<label htmlFor={ this.uid }>
						<span dangerouslySetInnerHTML={ { __html: label } } />

						{ required &&
							<span className="-required"> *</span>
						}
					</label>
				}

				{ expand &&
					<div className="form-textarea-expand" ref={ this.refExpand }></div>
				}

				<textarea
					ref={ this.refTextarea }
					id={ this.uid }
					name={ id }
					value={ theValue }
					rows={ rows }
					placeholder={ placeholder }
					required={ required }
					onChange={ this.handleChange }
					onKeyDown={ this.handleKeyDown }
					onInput={ this.handleInput }
				/>
			</div>
		)
	}
}

export default Textarea
